/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Code_LabelInputs */

const vi_trace_code_label = /** @type {(inputs: Trace_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã ngắn`)
};

/**

* @param {Trace_Code_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_code_label = /** @type {((inputs?: Trace_Code_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Code_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_code_label(inputs)
});